/****************************************************************************
 * COPYRIGHT (c) 2025 Harman Connected Services
 *
 * All rights reserved
 *
 * This software embodies materials and concepts which are
 * confidential to Ignite Product and is made available solely
 * pursuant to the terms of a written license agreement with
 * Ignite Product.
 *
 * Designed and Developed by Harman International Industries, Inc.
 ***************************************************************************/
import APIManager from "../../ApiManager/ApiManager";
import {
  FETCH_DOMAIN_APPROVER_HEAD_UNIT_REQUEST,
  FETCH_DOMAIN_APPROVER_HEAD_UNIT_SUCCESS,
  FETCH_DOMAIN_APPROVER_HEAD_UNIT_FAILURE,
} from "./DomainApproverHeadUnitTypes";
import { COMMON_ERROR } from "../ApplicationDetailsError/ApplicationDetailsErrorTypes";

export const fetchDomainApproverHeadUnitRequest = () => {
  return {
    type: FETCH_DOMAIN_APPROVER_HEAD_UNIT_REQUEST,
  };
};

export const fetchDomainApproverHeadUnitSuccess = (HeadUnitData) => {
  return {
    type: FETCH_DOMAIN_APPROVER_HEAD_UNIT_SUCCESS,
    payload: HeadUnitData,
  };
};

export const fetchDomainApproverHeadUnitFailure = (error) => {
  return {
    type: FETCH_DOMAIN_APPROVER_HEAD_UNIT_FAILURE,
    payload: error,
  };
};

export const fetchDomainApproverHeadUnitDetails = (domainAliasId) => {
  return (dispatch) => {
    dispatch(fetchDomainApproverHeadUnitRequest());

    APIManager.getDomainApproverHeadUnit(domainAliasId)
      .then((response) => {
        const headUnits = response.results || response.data || response;
        dispatch(fetchDomainApproverHeadUnitSuccess(headUnits));
      })
      .catch((error) => {
        const errorMsg = error.message || "Failed to fetch head unit data";
        dispatch(fetchDomainApproverHeadUnitFailure(errorMsg));
      });
  };
};

export const commonError = (error, errorType) => {
  return {
    type: COMMON_ERROR,
    payload: {
      message: error.message,
      errorType: errorType,
    },
  };
};
